import React, { useContext, useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import classNames from "classnames/bind";
import webWallet from "../../libs/web-wallet";
import { GlobalContext } from "./../../state/global/globalContext";
import useMedia from "use-media";
import keyfile from "../../libs/keyfile";
//Style
import "./style.scss";

const MENUITEM = [
    {
        title: "Create & Restore",
        link: "/CreateRestore",
        icon: "CreateRestore",
        withAuth: false,
        childs: [
            {
                title: "Generate New Wallet",
                link: "/GenerateWallet",
                icon: "GenerateWallet",
                withAuth: false,
            },
            {
                title: "Create From Mnemonic",
                link: "/CreateFromMnemonic",
                icon: "CreateFromMnemonic",
                withAuth: false,
            },
            {
                title: "Restore From Mnemonic",
                link: "/RestoreWallet",
                icon: "RestoreWallet",
                withAuth: false,
            },

            {
                title: "Restore From WIF",
                link: "/RestoreFromWallet",
                icon: "RestoreFromWallet",
                withAuth: false,
            },
            // {
            //     title: "Restore From Mobile Wallet",
            //     link: "/RestoreFromMobileWallet",
            //     icon: "RestoreFromMobileWallet",
            //     withAuth: false,
            // },
            {
                title: "Restore From Key File",
                link: "/RestoreFromKeyFile",
                icon: "RestoreFromKeyFile",
                withAuth: false,
            },
        ],
    },
    // {
    //     title: "Offline Staking",
    //     link: "/OfflineStaking",
    //     icon: "OfflineStaking",
    //     withAuth: true,
    //     childs: [
    //         {
    //             title: "Add Delegation",
    //             link: "/AddDelegation",
    //             icon: "AddDelegation",
    //             withAuth: true,
    //         },
    //         {
    //             title: "OfflineStacking",
    //             link: "/OfflineStackingList",
    //             icon: "OfflineStackingList",
    //             withAuth: true,
    //         },
    //     ],
    // },
    {
        title: "Wallet",
        link: "/Wallet",
        icon: "Wallet",
        withAuth: true,
        childs: [
            {
                title: "View Wallet Info",
                link: "/WalletInfo",
                icon: "WalletInfo",
                withAuth: true,
            },
            {
                title: "View Wallet Tx",
                link: "/ViewTx",
                icon: "ViewTx",
                withAuth: true,
            },

            // {
            //     title: 'Safe Send',
            //     link: '/SafeSend',
            //     icon: 'SafeSend',
            //     withAuth: false,
            // },
            {
                title: "Send",
                link: "/Send",
                icon: "Send",
                withAuth: true,
            },
            {
                title: "Request Payment",
                link: "/RequestPayment",
                icon: "RequestPayment",
                withAuth: true,
            },
            {
                title: "Dump As Key File",
                link: "/DumpKeyFile",
                icon: "DumpKeyFile",
                withAuth: true,
            },
        ],
    },
    {
        title: "Token & Contracts",
        link: "/TokenContracts",
        icon: "TokenContracts",
        withAuth: true,
        childs: [
            {
                title: "Create Token",
                link: "/CreateToken",
                icon: "CreateToken",
                withAuth: true,
            },
            {
                title: "Create Contract",
                link: "/CreateContract",
                icon: "CreateContract",
                withAuth: true,
            },

            {
                title: "Send To Contract",
                link: "/SendToContract",
                icon: "SendToContract",
                withAuth: true,
            },
        ],
    },
    {
        title: "Setting",
        link: "/Setting",
        icon: "Setting",
        withAuth: false,
    },
    // {
    //     title: "Logout",
    //     link: "/Logout",
    //     icon: "Logout",
    //     withAuth: true,
    // },
];

const NavItem = ({ link, icon, title, childs, open, onClick, setIsToggle }) => {
    return (
        <li className="menu-list-item">
            <div
                onClick={() => {
                    if (childs) {
                        onClick(link);
                    } else {
                        setIsToggle(false);
                    }
                }}
            >
                <NavLink
                    to={link}
                    className={classNames("menu-list-item-link", childs && "disabled-link")}
                    activeClassName="menu-list-item-active"
                >
                    <i className={`icon-${icon} px-5 menu-list-item-icon`} />
                    <span>{title}</span>
                    {childs && <i className={`icon-${open ? "chevron-up" : "chevron-down"} menu-list-item-arrow`} />}
                </NavLink>
            </div>

            {childs && open && (
                <ul>
                    {childs.map((item, i) => {
                        return (
                            <NavItem
                                key={"menu-child-" + link + i}
                                {...item}
                                link={link + item.link}
                                setIsToggle={setIsToggle}
                            />
                        );
                    })}
                </ul>
            )}
        </li>
    );
};

const Navbar = () => {
    const { isToggle, setIsToggle, password } = useContext(GlobalContext);
    const isMobile = useMedia({ maxWidth: "991px" });
    const history = useHistory();

    const [wallet, setWallet] = useState();
    const [currentOpen, setCurrentOpen] = useState();

    const restore = (wif) => {
        try {
            webWallet.restoreFromWif(wif);
            setTimeout(() => {
                
                history.push("/Wallet/WalletInfo");
            }, 1000);
        } catch (e) {
            // notification.error('restore_wif_fail')
            // notification.logError('restore_wif_restore_error', e.stack || e.toString() || e)
            return false;
        }
    };

    useEffect(
        () =>
            history.listen(() => {
                const _wallet = webWallet.getWallet();

                if (_wallet) {
                    setWallet(_wallet);

                    // localStorage.setItem("wallet", keyfile.encode(_wallet?.getPrivKey(), password));
                } else {
                    if (
                        !(
                            history.location.pathname.includes("/CreateRestore") ||
                            history.location.pathname.includes("/Setting")
                        )
                    ) {
                        history.push("/CreateRestore/GenerateWallet");
                    }
                }
                if (_wallet == null) {
                    setWallet(null);
                }

                // eslint-disable-next-line react-hooks/exhaustive-deps
            }),
        [],
    );
    useEffect(() => {
        const _wallet = webWallet.getWallet();

        if (_wallet) {
            setWallet(_wallet);

            // localStorage.setItem("wallet", keyfile.encode(_wallet?.getPrivKey(), password));
        } else {
            if (
                !(
                    history.location.pathname.includes("/CreateRestore") ||
                    history.location.pathname.includes("/settings")
                )
            ) {
                history.push("/CreateRestore/GenerateWallet");
            }
            // if (localStorage.getItem("wallet")) {
            //     restore(keyfile.decode(localStorage.getItem("wallet"), password));
            // }
        }
    }, []);

    return (
        <div className={classNames("menu", isToggle && "menu-hidden")}>
            <div className="menu-list">
                <ul>
                    {wallet ? (
                        <>
                            {MENUITEM?.map((item, i) => {
                                return (
                                    <NavItem
                                        key={"menu-" + i}
                                        {...item}
                                        open={currentOpen === item.link ? true : false}
                                        setIsToggle={() => {
                                            setTimeout(() => {
                                                isMobile && setIsToggle(!isToggle);
                                            }, 500);
                                        }}
                                        onClick={(link) => {
                                            if (currentOpen === link) {
                                                setCurrentOpen(null);
                                            } else {
                                                setCurrentOpen(link);
                                            }
                                        }}
                                    />
                                );
                            })}
                        </>
                    ) : (
                        <>
                            {MENUITEM?.filter((i) => !i.withAuth).map((item, i) => {
                                return (
                                    <NavItem
                                        key={"menu-" + i}
                                        {...item}
                                        open={currentOpen === item.link ? true : false}
                                        setIsToggle={() => {
                                            setTimeout(() => {
                                                isMobile && setIsToggle(!isToggle);
                                            }, 500);
                                        }}
                                        onClick={(link) => {
                                            if (currentOpen === link) {
                                                setCurrentOpen(null);
                                            } else {
                                                setCurrentOpen(link);
                                            }
                                        }}
                                    />
                                );
                            })}
                        </>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default Navbar;
